export function isParticipantCopy(participant: { parent_participant_id: number | null }): boolean {
    return participant.parent_participant_id !== null;
}
